/* eslint-disable camelcase */
import jwt_decode from "jwt-decode";

const TokenDecode = (token) => jwt_decode(token);

export default TokenDecode;